
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informazioni-utili/video-tutorial/[slug]",
      function () {
        return require("private-next-pages/informazioni-utili/video-tutorial/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/informazioni-utili/video-tutorial/[slug]"])
      });
    }
  